import { GenericObjectArrayType, IFormSection } from "../../types/common";
import DetailsCard from "../../components/common/DetailsCards";
import { beautify, numberFormat } from "../../utils/helpers";
import { API_PAYMENT_METHODS, API_PAYMENTS } from "../../utils/apis";
import { useEffect } from "react";
import useGet from "../common/useGet";

export const usePaymentsForm = ({ form, id }) => {
  const sections: IFormSection[] = [
    {
      title: "Invoice Details",
      visible: id && form,
      fields: [
        {
          field_name: "prn",
          type: "component",
          component: (
            <DetailsCard
              viewData={{
                invoice_amount: numberFormat(
                  form?.prn?.invoice_details?.amount,
                ),
                invoice_amount_paid: numberFormat(
                  form?.prn?.invoice_details?.amount_paid,
                ),
                invoice_payment_status:
                  form?.prn?.invoice_details?.payment_status,
              }}
            />
          ),
          props: {
            wide: true,
          },
        },
      ],
    },
    {
      title: "Payment Information",
      fields: [
        {
          field_name: "invoice_amount",
          type: "number",
          label: "Invoice Amount",
          value: form?.prn?.invoice_details?.amount || 0,
          visible: (form?.prn?.invoice_details?.amount || 0) > 0,
          props: { disabled: true, smallWidth: true },
        },
        {
          field_name: "amount",
          type: "number",
          label: "Amount",
          props: { required: true, smallWidth: true },
        },
        {
          field_name: "payment_mode",
          type: "select",
          label: "Payment Method",
          value: form?.payment_mode || form?.prn?.payment_mode,
          props: { required: true, smallWidth: true },
          options_name: "payment_methods",
        },
        {
          field_name: "payment_date",
          type: "date",
          label: "Payment Date",
          props: {
            required: true,
            smallWidth: true,
          },
        },
      ],
    },
  ];
  const getConfigOptions = () => {
    const { loadData: getPaymentMethods, data: paymentMethods } = useGet();

    const getResultOptions = (
      data: any[] | Record<string, any>,
      itemName: string | undefined,
      key?: string | undefined | null,
    ) => {
      const results = Array.isArray(data) ? data : data?.results || [];
      return results.length
        ? results.map((item: GenericObjectArrayType) => ({
            id: key ? item[key] : item.id,
            name: beautify(
              `${(itemName && item[itemName]) || ""}`.trim() || item.name,
            ),
            data: item,
          }))
        : [];
    };
    useEffect(() => {
      getPaymentMethods({
        api: API_PAYMENT_METHODS,
        params: { active: true },
      });
    }, []);
    return {
      payment_methods: getResultOptions(paymentMethods, "mode", "id"),
    };
  };
  const options = {
    ...getConfigOptions(),
  };

  const redirect = `/payments/view/${id}`;

  return { sections, redirect, options };
};

export function submitPayments(payload: any, id: number | null) {
  if (id) {
    return {
      id,
      api: API_PAYMENTS,
      params: payload,
    };
  }
  // on create
  //   return {
  //     api: API_PAYMENTS,
  //     params: payload,
  //   };
}
